var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggler",on:{"click":_vm.toggleSidebarMobile}},[_c('BaseIcon',{attrs:{"icon":"icon-Hamburger-menu","extraClass":"toggler__icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }